import { Field, RadioGroup, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import {
  IWorksheetComponent,
  WorksheetChartSection,
  WorksheetsResultsMessagesSection,
} from 'Components/Worksheets/Core';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { MCVInterpretationMethod } from '../types';

export interface IResultsSectionProps extends IWorksheetComponent {
  chartNamePrefix?: string;
}

let ResultsSection: React.FC<IResultsSectionProps> = ({ createWorksheetSelector, namePrefix, chartNamePrefix }) => {
  const interpretationMethodOptions: Array<{ label: string; value: MCVInterpretationMethod }> = [
    { label: 'Steepest straight line', value: MCVInterpretationMethod.SteepestStraightLine },
    { label: 'Curve of best fit', value: MCVInterpretationMethod.CurveOfBestFit },
  ];

  const isMoreThan18 = useSelector(
    pipe(createWorksheetSelector!('Results.MoistureConditionValueText'), (mcv: string) => {
      return mcv === 'More than 18';
    })
  );

  return (
    <>
      <NamePrefixModifier namePrefix={chartNamePrefix}>
        <WorksheetChartSection wide height={500} />
      </NamePrefixModifier>

      <ListFieldSection>
        <Field
          input={<RadioGroup />}
          name="Results.InterpretationMethod"
          options={interpretationMethodOptions}
          visible={!isMoreThan18}
        />
        <Field
          input={<TextOutput />}
          name="Results.InterpretationMethod"
          value={'More than 256 blows required'}
          visible={isMoreThan18}
        />

        <Field input={<TextOutput />} name="Results.WaterContentPercent" />
        <Field input={<TextOutput />} name="Results.MoistureConditionValueText" />
      </ListFieldSection>
      <WorksheetsResultsMessagesSection />
    </>
  );
};

ResultsSection = withInjectedProps(ResultsSection);

export { ResultsSection };
export default ResultsSection;
